import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "person-overlay__scroller" }
const _hoisted_2 = { class: "person-overlay__content" }
const _hoisted_3 = {
  key: 0,
  class: "person-overlay__resort-list"
}
const _hoisted_4 = { class: "person-overlay__resort-list-item" }
const _hoisted_5 = { class: "person-overlay__resort-list-item-name" }
const _hoisted_6 = { class: "person-overlay__name" }
const _hoisted_7 = {
  key: 1,
  class: "person-overlay__text"
}
const _hoisted_8 = { class: "person-overlay__extras" }
const _hoisted_9 = {
  key: 0,
  class: "extras__button-read-more"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "button__text" }
const _hoisted_12 = { class: "extras__socials" }
const _hoisted_13 = { class: "extras__socials-item" }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["xlink:href"]
const _hoisted_16 = {
  key: 0,
  class: "person-overlay__picture-container"
}
const _hoisted_17 = { class: "person-overlay__picture" }
const _hoisted_18 = ["src", "alt", "width", "height"]

import { onMounted } from 'vue';
import { customLog } from '../../../../javascripts/utils/log';


export default {
  __name: 'person-overlay',
  props: {
  personName: {
    type: String,
    required: true,
    validator: (personName) => personName.length > 0
  },
  personInfoText: {
    type: String,
    required: true,
    validator: (personInfoText) => personInfoText.length > 0,
  },
  personImage: {
    type: Object,
    required: true,
    validator: (personImage) => personImage.src && personImage.alt && personImage.width && personImage.height,
  },
  readMoreButton: {
    type: Object,
    required: true,
    validator: (readMoreButton) => readMoreButton.label && readMoreButton.link,
  },
  resorts: {
    type: Array,
    required: true,
    validator: (resorts) => resorts.length > 0,
  },
  socials: {
    type: Array,
    required: false,
    default: () => [],
  }
},
  emits: {
  closeOverlay: () => {
    customLog('[PersonOverlay] closeOverlay event emitted');

    return true
  }
},
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleCloseButtonClick = () => {
  customLog('[PersonOverlay] received close button click event');
  emit('closeOverlay')
}

const handleBackgroundClick = (event) => {
  customLog('[PersonOverlay] received background click event');
  emit('closeOverlay')
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "person-overlay",
    onClick: handleBackgroundClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "person-overlay__inner",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", {
          class: "person-overlay__button-close",
          onClick: _withModifiers(handleCloseButtonClick, ["stop","prevent"])
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("a", {
            class: "button button--icon-only",
            href: "#",
            id: "resort-overlay__button-close"
          }, [
            _createElementVNode("svg", {
              class: "icon icon--close button__icon",
              viewBox: "0 0 200 200",
              "aria-hidden": "true"
            }, [
              _createElementVNode("use", { "xlink:href": "#icon-close" })
            ])
          ], -1)
        ])),
        _createElementVNode("div", _hoisted_2, [
          (__props.resorts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.resorts, (resort) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(resort), 1)
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.personName), 1),
          (__props.personInfoText)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.personInfoText), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (__props.readMoreButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("a", {
                    class: "button",
                    href: __props.readMoreButton.link,
                    id: "person-overlay__button-read-more"
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(__props.readMoreButton.label), 1)
                  ], 8, _hoisted_10)
                ]))
              : _createCommentVNode("", true),
            (__props.socials)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.socials, (social) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("a", {
                        class: "button button--icon-only button--secondary",
                        href: social.link
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass(["icon button__icon", `icon--${social.icon}`]),
                          viewBox: "0 0 200 200",
                          "aria-hidden": "true"
                        }, [
                          _createElementVNode("use", {
                            "xlink:href": `#icon-${social.icon}`
                          }, null, 8, _hoisted_15)
                        ], 2))
                      ], 8, _hoisted_14)
                    ])
                  ]))
                }), 256))
              : _createCommentVNode("", true)
          ])
        ]),
        (__props.personImage && __props.personImage.src)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("img", {
                  src: __props.personImage.src,
                  alt: __props.personImage.alt,
                  width: __props.personImage.width,
                  height: __props.personImage.height
                }, null, 8, _hoisted_18)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

}